import RoutesMap from "../../route_control/RouteControl"
import {
    Profile
} from "../../pages/user"

export const UsersImport = {
    RoutesMap,
    Profile,
}